var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-stats',{staticClass:"products-listing-results-count",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var nbHits = ref.nbHits;
return [_c('span',{staticClass:"products-listing-results-count__number"},[_vm._v(_vm._s(nbHits))]),_vm._v("\n    "+_vm._s(_vm.name)+_vm._s(nbHits === 1 ? '' : 's')+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }